import React, { FC, useEffect, useState } from "react";
import { getMailboxFolders } from "../../../../../services/get.data.service";
import FormControl from "@material-ui/core/FormControl/FormControl";
import { MailboxFolder } from "../../../../../models/mailboxFolder";

type Props = {
  allowInbox?: boolean;
  buttonText: string;
  emailAddress: string;
  mailboxFolder: MailboxFolder|null;
  setMailboxFolder: (value: MailboxFolder) => void;
};

const MailboxFoldersInput: FC<Props> = ({ allowInbox, buttonText, emailAddress, mailboxFolder, setMailboxFolder }) => {

  const [loading, setLoading] = useState<boolean>(false);
  const [mailboxFolders, setMailboxFolders] = useState<MailboxFolder[]>([]);
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [error, setError] = useState<string|null>(null);

  const getFolders = async (): Promise<void> => {
    const requestedEmailAddress = emailAddress.trim();
    setLoading(true);
    const response = await getMailboxFolders(requestedEmailAddress);
    if (requestedEmailAddress !== emailAddress.trim()) { // email address has changed during the request, do nothing
      setLoading(false);
      return;
    }
    if (!response.success || !Array.isArray(response.data) || response.data.length === 0) {
      setError("No mailbox subfolders found.");
      setLoading(false);
      return;
    }

    const folders = allowInbox ? [{ id: "inbox", name: "Inbox" }, ...response.data] : response.data;
    setMailboxFolders(folders);
    if (mailboxFolder === null && folders.length > 0) {
      setMailboxFolder(folders[0]);
    }
    if (mailboxFolder !== null && !folders.some(folder => folder.id === mailboxFolder.id)) {
      setMailboxFolder(folders[0]);
    }
    setLoading(false);
    setShowDropdown(true);
  };

  useEffect(() => {
    setLoading(false);
    setShowDropdown(false);
    setMailboxFolders([]);
    setError(null);
  }, [emailAddress]);

  return (
    <>
      <div className="form-group">
        {!showDropdown && (
          <>
            {!loading ? (
              error ? (
                <div className="text-danger">{error}</div>
              ) : (
                <button className="btn btn-secondary" onClick={getFolders} disabled={loading}>
                  {buttonText}
                </button>
              )
            ) : (
              <i className="fas fa-spinner fa-spin"></i>
            )}
          </>
        )}
      </div>
      {showDropdown && (
        <div className="form-group">
          <label htmlFor="mailbox-folder">Mailbox Folder</label>
          <FormControl>
            <select
              name="mailbox-folder"
              id="mailbox-folder"
              value={mailboxFolder?.id||mailboxFolders[0].id}
              onChange={(event): void => {
                const folder = (mailboxFolders.find(folder => folder.id === event.target.value) as MailboxFolder);
                setMailboxFolder(folder);
              }}
            >
              {mailboxFolders.map((folder: MailboxFolder, i: number) => {
                return (
                  <option value={folder.id} key={i}>
                    {folder.name}
                  </option>
                );
              })}
            </select>
          </FormControl>
        </div>
      )}
    </>
  );
};

export default MailboxFoldersInput;